import { lazy, Suspense } from 'react';
import { Loader2 } from '../../shared/icons';
import { registerCapability } from '../../shared/platform/registry';

/** 词条查词弹窗懒加载：english 被平台禁用时整块代码不进包。 */
const WordLookupDialog = lazy(() =>
  import('./components/WordLookupDialog').then((m) => ({
    default: m.WordLookupDialog,
  })),
);

/** english 向平台注册的能力。词条的渲染与发音都归 english 所有，
 *  消费方（notebook 右键查词等）只拿契约，不感知实现。english
 *  从平台装配清单（shared/platform/apps.ts）移除后，查词入口
 *  在所有消费方自动收起。 */
export function registerEnglishCapabilities(): void {
  registerCapability('dictionary.lookup', {
    label: '查词',
    render: ({ query, onClose }) => (
      <Suspense
        fallback={
          <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/30">
            <Loader2 className="size-5 animate-spin text-neutral-400" />
          </div>
        }
      >
        <WordLookupDialog query={query} onClose={onClose} />
      </Suspense>
    ),
  });
}
